export default "__VITE_ASSET__DMW_s$cE__"